'use client';

import { c as _c } from "react/compiler-runtime";
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { UserCredential, signInWithEmailAndPassword } from 'firebase/auth';
import Image from 'next/image';
import { useSearchParams } from 'next/navigation';
import { ReactElement, useCallback, useState } from 'react';
import { useLoadingCallback } from 'react-loading-hook';
import minimalLogo from '../../../assets/minimal-logo.png';
import { CenterPage } from '../../../components/CenterPage';
import { getFirebaseAuth, loginWithGoogle } from '../../../libs/auth/firebase';
import { getSignInErrorMessage, signInErrorParam } from '../../../libs/auth/signInError';
import { useRedirectAfterLogin } from '../../../libs/auth/useRedirectAfterLogin';
import { loginWithCredential } from '../../api';
import { GoogleIcon } from './_GoogleIcon/GoogleIcon';
import { PasswordForm, PasswordFormValue } from './_PasswordForm';
export default function SignIn() {
  const $ = _c(32);
  const [hasLogged, setHasLogged] = useState(false);
  const redirectAfterLogin = useRedirectAfterLogin();
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = getSignInErrorMessage(searchParams?.get(signInErrorParam) ?? null);
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const redirectedErrorMessage = t0;
  let t1;
  if ($[2] !== redirectAfterLogin) {
    t1 = async function (credential) {
      await loginWithCredential(credential);
      redirectAfterLogin();
    };
    $[2] = redirectAfterLogin;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleLogin = t1;
  let t2;
  if ($[4] !== handleLogin) {
    t2 = async t3 => {
      const {
        email,
        password
      } = t3;
      setHasLogged(false);
      const auth = getFirebaseAuth();
      await handleLogin(await signInWithEmailAndPassword(auth, email, password));
      setHasLogged(true);
    };
    $[4] = handleLogin;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const [handleLoginWithEmailAndPassword, isEmailLoading, emailPasswordError, resetEmailPasswordError] = useLoadingCallback(t2);
  let t3;
  if ($[6] !== handleLogin) {
    t3 = async () => {
      setHasLogged(false);
      const auth_0 = getFirebaseAuth();
      await handleLogin(await loginWithGoogle(auth_0));
      setHasLogged(true);
    };
    $[6] = handleLogin;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const [handleLoginWithGoogle, isGoogleLoading, googleError, resetGoogleError] = useLoadingCallback(t3);
  let t4;
  if ($[8] !== handleLoginWithEmailAndPassword || $[9] !== resetGoogleError) {
    t4 = function handleEmailAndPasswordSubmit(value) {
      resetGoogleError();
      handleLoginWithEmailAndPassword(value).catch(_temp);
    };
    $[8] = handleLoginWithEmailAndPassword;
    $[9] = resetGoogleError;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const handleEmailAndPasswordSubmit = t4;
  let t5;
  if ($[11] !== handleLoginWithGoogle || $[12] !== resetEmailPasswordError) {
    t5 = function handleGoogleClick() {
      resetEmailPasswordError();
      handleLoginWithGoogle().catch(_temp2);
    };
    $[11] = handleLoginWithGoogle;
    $[12] = resetEmailPasswordError;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const handleGoogleClick = t5;
  const loginError = emailPasswordError ?? googleError;
  let t6;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Image src={minimalLogo} alt="Jesus Film Project" width={70} height={70} />;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== hasLogged) {
    t7 = hasLogged && <Box sx={{
      height: 300,
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }}><CircularProgress /></Box>;
    $[15] = hasLogged;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== hasLogged || $[18] !== loginError || $[19] !== redirectedErrorMessage) {
    t8 = !hasLogged && loginError == null && redirectedErrorMessage != null && <Alert severity="error" sx={{
      width: "100%"
    }}>{redirectedErrorMessage}</Alert>;
    $[17] = hasLogged;
    $[18] = loginError;
    $[19] = redirectedErrorMessage;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== handleEmailAndPasswordSubmit || $[22] !== handleGoogleClick || $[23] !== hasLogged || $[24] !== isEmailLoading || $[25] !== isGoogleLoading || $[26] !== loginError) {
    t9 = !hasLogged && <PasswordForm loading={isEmailLoading} onSubmit={handleEmailAndPasswordSubmit} error={loginError}><Button variant="outlined" loading={isGoogleLoading} disabled={isGoogleLoading} onClick={handleGoogleClick} startIcon={<GoogleIcon />} fullWidth={true}>Sign in with Google</Button></PasswordForm>;
    $[21] = handleEmailAndPasswordSubmit;
    $[22] = handleGoogleClick;
    $[23] = hasLogged;
    $[24] = isEmailLoading;
    $[25] = isGoogleLoading;
    $[26] = loginError;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== t7 || $[29] !== t8 || $[30] !== t9) {
    t10 = <CenterPage>{t6}{t7}{t8}{t9}</CenterPage>;
    $[28] = t7;
    $[29] = t8;
    $[30] = t9;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  return t10;
}
function _temp2() {}
function _temp() {}